var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"version-description"},[_c('p',{staticClass:"d-title"},[_vm._v("更新说明")]),_c('p',{staticClass:"d-desc",domProps:{"innerHTML":_vm._s(_vm.desc || '无')}})])}
var staticRenderFns = []

export { render, staticRenderFns }